import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { asyncScrollTo as _asyncScrollTo } from '@/utility';
export default defineComponent({
  name: 'SearchResultSnippetsEntry',
  props: {
    entry: {
      type: Object,
      required: true
    },
    excerpt: {
      type: Object,
      required: true
    },
    width: {
      type: String,
      required: true
    },
    isSnippetSelected: {
      type: Boolean,
      required: true
    },
    sectionPointer: {
      type: [String, undefined],
      required: false,
      default: undefined
    }
  },
  emits: ['mouseenter'],
  setup: function setup() {
    var container = ref();
    var asyncScrollTo = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(cursor) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(container.value === undefined)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return _asyncScrollTo(cursor, container.value, {
                behavior: 'smooth'
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function asyncScrollTo(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    onMounted(function () {
      console.log(container.value);
    });
    return {
      asyncScrollTo: asyncScrollTo,
      container: container
    };
  }
});